import { ActionGet } from '../../actiontracker/model/actionGet';
import { ObservationCategoryModel } from '../../masterscreen/model/observation-category.model';
import { User } from './user.model';

export class ObservationRequest {
  ObservationId: number;
  DisplayId: string;
  ObservationDate: Date = new Date();
  EmployeeName: string;
  RaisedBy: number;
  RaisedFor: number;
  ObservationTypes: number[] = [];
  LocationId: number;
  ExactLocation: String;
  WhatObserved: string = '';
  WhatYouDid: string = '';
  IsJobStopped: Boolean;
  WhatWeCouldDo: String = '';
  Feedback: string;
  NotListed: String;
  StatusId: number;
  ActorId: Boolean;
  CompanyId: number;
  HazardTypes: number[];
  ObservationTypeValue: number[];
  ObservationTypeId: number;
  ObservationType: String;
  LocationName: String;
  CancellationReason: string;
  HazardType: number[];
  SetObservationTypes: any;
  Status: string;
  CreatedDate: Date;
  WhatYouDidFiles: any[] = [];
  WhatWeCouldDoFiles: any[] = [];
  WhatObservedFiles: any[] = [];
  UpdatedDate: Date;
  ClosureReason: string;
  ClosureDate: Date;
  AcknowledgmentReason: string;
  AcknowledgmentDate: Date;
  CancellationDate: Date;
  DeletionReason: string;
  DeletionDate: Date;
  WhatYouDidFileURL: string;
  WhatWeCouldDoFileURL: string;
  WhatObservedFileURL: string;
  ObservationRaiseUser: User;
  ObservationCategoryId: number;
  ObservationCategoryName: string;
  HSEAdvisorFeedBack: string;
  restatereason: string;
  AllWhatYouDidFileURL: string;
  AllWhatObservedFileURL: string;
  AllWhatWeCouldDoFileURL: string;
  TimeZone: string;
  UnitId: number;
  WhatIsTheReason: string = '';
  HSEAdvisorFeedBackFiles: any[] = [];
  IsDraft: boolean = false;
  IsUpdatedDraft: boolean = false;
  Contract:number=0;
}


export class ObservationRequsetsForDashboard {
  ObservationRequests: ObservationRequest;
  RaisedForFullName: string;
}

export class ViewRequestForObservation {
  ObservationRequests: ObservationRequest;
  HseAdviserUsersDetails: User;
  ActionRequests: ActionGet;
  ObservationCategoryDetails: ObservationCategoryModel;
  ObservationRaiseUser: User;
}
export class AcknowledgmentRequest {
  ObservationRequestId: number;
  AcknowledgmentReason: string;
  AcknowledgedBy: number;
  IpAddress: string;
  HSEAdvisorFeedBackFiles: any[] = [];
}
